export const HOME_EXTRA = {
    heroPrimaryCta: "hero-primary-cta",
    heroWhatsappCta: "hero-whatsapp-cta",
    heroCallCta: "hero-call-cta",
    heroForm: "hero-quote-form",
    heroFormSubmit: "hero-quote-form-submit",
    servicesSection: "services-section",
    servicesCard: "services-card",
    faqAccordion: "faq-accordion",
    faqItemTrigger: "faq-item-trigger",
    finalCtaPrimary: "final-cta-primary-button",
    finalCtaWhatsapp: "final-cta-whatsapp-button",
    reviewsPlaceholder: "reviews-placeholder",
};

export const HEADER = {
    root: "site-header",
    nav: "site-header-nav",
    call: "site-header-call-button",
    whatsapp: "site-header-whatsapp-button",
    quote: "site-header-quote-button",
    logo: "site-header-logo",
    mobileMenuToggle: "site-header-mobile-toggle",
};

export const STICKY_BAR = {
    root: "mobile-sticky-contact-bar",
    call: "mobile-sticky-call-button",
    whatsapp: "mobile-sticky-whatsapp-button",
    quote: "mobile-sticky-quote-button",
};

export const QUOTE = {
    form: "quote-form",
    next: "quote-form-next-button",
    back: "quote-form-back-button",
    submit: "quote-form-submit-button",
    successRef: "quote-form-success-reference",
    successWhatsapp: "quote-form-success-whatsapp-button",
    stepIndicator: "quote-form-step-indicator",
};

export const CONTACT_IDS = {
    form: "contact-form",
    submit: "contact-form-submit",
};

export const ADMIN = {
    loginForm: "admin-login-form",
    loginSubmit: "admin-login-submit",
    leadsTable: "admin-leads-table",
    leadsRow: "admin-leads-row",
    leadsSearch: "admin-leads-search-input",
    leadsFilter: "admin-leads-filter-button",
    leadsExport: "admin-leads-export-csv-button",
    statCard: "admin-stat-card",
    statValue: "admin-stat-card-value",
    timeline: "admin-lead-status-timeline",
    timelineItem: "admin-lead-status-timeline-item",
    logout: "admin-logout-button",
};

export const COOKIE = {
    banner: "cookie-banner",
    accept: "cookie-banner-accept",
    reject: "cookie-banner-reject",
    manage: "cookie-banner-manage",
};
